import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import zhTW from './locales/zh-TW.js'
import en from './locales/en.js'

import '@/assets/css/styles.css'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  warnHtmlMessage: false,
  messages: {
    'zh-TW': zhTW,
    en,
  },
})

createApp(App).use(i18n).mount('#app')
